import React from 'react'
import './SectionTitle.sass'

function SectionTitle({ title }) {
  return <h5 className="SectionTitle">{title}</h5>
}

export default SectionTitle
